import {of} from 'rxjs';
import {distinctUntilChanged, filter, map, mapTo, shareReplay, switchMap, take, tap} from 'rxjs/operators';
import {fiatAccountApi} from '@/api/fiat-account';
import {userStatus$} from '@/streams/auth';
import {isSubAccount$, openSubAccountWarning} from './components/with-main-account/utils';

/**
 * @param {{LG: any}} params
 */
export function createAuthEffectStream(params) {
  const {LG} = params;
  return isSubAccount$.pipe(
    take(1),
    tap((isSubAccount) => {
      if (isSubAccount) {
        openSubAccountWarning(LG);
      }
    }),
    filter((isSubAccount) => !isSubAccount),
    mapTo(params)
  );
}

const isLogin$ = userStatus$.pipe(
  filter((userStatus) => userStatus !== 'Init'),
  map((userStatus) => userStatus === 'Login')
);

const abtest$ = isLogin$.pipe(
  switchMap((isLogin) => (isLogin ? getFiatBizGary() : of({creditCardsBuyCrypto: false, fiatDepositWithdraw: false, creditCardsSellCrypto: false}))),
  shareReplay(1)
);

export const fiatABTest$ = abtest$.pipe(
  map((abtest) => abtest.fiatDepositWithdraw),
  distinctUntilChanged()
);

export const creditCardABTest$ = abtest$.pipe(map((abtest) => ({buy: abtest.creditCardsBuyCrypto, sell: abtest.creditCardsSellCrypto})));

async function getFiatBizGary() {
  const response = await fiatAccountApi.getFiatBizGary();
  return response.data || {};
}
